<div class="d-flex spacing-8 value-data align-items-center" [class.space]="space">
  <div class="col-lg-4 bg-height">
    <span class="text-nowrap d-flex align-items-center spacing-8 h4-reg primary-60 w-150">
      <app-ce-icon
        name="{{ title_icon }}"
        [color]="'var(--primary-50)'"
        [svg_class]="['primary-50']"></app-ce-icon
      >{{ title }}</span
    >
  </div>
  <div class="col-lg-6 w-100 bg-hover bg-height" [class.right]="space">
    <div [class.copied]="copy" [class.link]="link">
      <div class="value-options dropdown" [class.d-none]="text" [class.readonly]="readOnly">
        <div
          class="value-type"
          [class.disabled]="readOnly"
          (click)="onStatus()"
          (keydown.enter)="onStatus()"
          (keydown.space)="onStatus()"
          (keydown.escape)="isOpen = false"
          [attr.tabindex]="readOnly ? -1 : 0"
          role="button"
          [attr.aria-label]="'Select ' + title"
          [attr.aria-expanded]="isOpen"
          [attr.aria-disabled]="readOnly"
          cdkOverlayOrigin
          #trigger="cdkOverlayOrigin"
          cdkConnectedOverlayPanelClass="example-panel">
          @if (valueType === 'customer' && currentValue) {
            <div
              [data]="{ customer: currentValue }"
              app-table-data
              Type="customer"
              customername="Darrell Steward"></div>
          }

          @if (valueType === 'text' && currentValue) {
            <h4 class="m-0 p-0 h4-bold primary-100">
              {{ currentValue }}
            </h4>
          }
          @if (!currentValue) {
            <p class="m-0 p-0 text-muted h4-bold primary-100">No value available</p>
          }

          @if (valueType === 'status' && currentValue) {
            <app-badges
              [withIcon]="currentValue.withIcon"
              [Type]="currentValue.Type"
              [uppercase]="currentValue.uppercase"
              [ellipsis]="currentValue.ellipsis"
              [IconType]="'dot'"
              label="{{ currentValue.label }}"></app-badges>
          }

          @if (valueType === 'tags' && currentValue) {
            <div class="tags d-flex align-items-center spacing-4">
              @for (tag of currentValue; track tag) {
                <app-tags [ellipsis]="true" [label]="tag.label" [close]="false"></app-tags>
              }
            </div>
          }

          @if (valueType === 'add-value') {
            <app-action-btn [active]="false"></app-action-btn>
          }

          <!-- @if (!currentValue) {
            <button type="button" class="assign-value d-flex align-items-center spacing-8">
              <span class="radio"></span>
              <span class="h4-bold">{{ emptyskeletonLabel }}</span>
            </button>
          } -->

          @if (valueType === 'date' && currentValue) {
            <h4 class="m-0 p-0 h4-bold primary-100">
              {{ currentValue.name | date: currentValue.format || 'dd MMM, yyyy' }}
            </h4>
          }
        </div>

        @if (isDropdown) {
          <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOpen]="isOpen"
            [cdkConnectedOverlayOrigin]="trigger"
            [cdkConnectedOverlayPositions]="[
              {
                originX: 'end',
                originY: 'bottom',
                overlayX: 'end',
                overlayY: 'top',
              },
              {
                originX: 'end',
                originY: 'top',
                overlayX: 'end',
                overlayY: 'bottom',
              },
            ]">
            <div class="assign-value-data w-100 dropdown-menus">
              @if (valueType === 'customer') {
                <app-customers
                  [state]="'default'"
                  [customers]="valueOptions"
                  (selectionChanged)="onSelectionChanged($event)"
                  (onClick)="setCurrentValue($event)">
                </app-customers>
              }

              @if (valueType !== 'customer') {
                <app-dropdown
                  [search]="false"
                  [dropdownStatus]="valueType === 'status'"
                  [dropdownList]="valueType !== 'status'"
                  [dropdown]="valueOptions"
                  [statusDropdown]="valueOptions"
                  (onClick)="setCurrentValue($event)"></app-dropdown>
              }
            </div>
          </ng-template>
        }
      </div>
      @if (copy) {
        <app-badges
          class="copyaddress"
          [withIcon]="true"
          [Type]="'tag'"
          [IconType]="iconName"
          [onlyIcon]="true"
          [withOutLabel]="true"
          label="z"
          [ellipsis]="false"
          [clickable]="true"
          (click)="copyUrl()"></app-badges>
      }
      @if (link) {
        <app-icon-btn
          [active]="false"
          [iconType]="linkIcon"
          [matTooltip]="tooltipText"
          [matTooltipPosition]="'above'"
          [size]="'medium'"
          (click)="onLinkClick()"></app-icon-btn>
        <!-- <app-link-btn
          class="d-flex"
          [label]="linkLabel"
          (custom_click)="onLinkClick()"
          [IconType]="linkIcon"></app-link-btn> -->
      }
    </div>
  </div>
</div>
